import {
  Divider,
  HStack,
  SimpleGrid,
  Text,
  VStack,
} from '@wegroup/design-system';
import React, { PropsWithChildren } from 'react';
import SmallBullet from '../../../../../design-system/src/content/components/SmallBullet';

interface Props {
  title: string;
  icon: React.ReactElement;
  isSelected?: boolean;
  onSelect: () => void;
}

const RiskObjectSelectRadio: React.FC<PropsWithChildren<Props>> = ({
  title,
  icon,
  isSelected,
  onSelect,
  children,
}) => {
  return (
    <VStack
      cursor="pointer"
      border="1px solid"
      borderColor={isSelected ? 'primary.500' : 'gray.50'}
      divider={<Divider borderColor="gray.50" />}
      onClick={onSelect}
      align="stretch"
      bg="white"
      borderRadius="md"
      boxShadow="level2"
    >
      <HStack p="4" spacing="4" justify="space-between">
        <HStack spacing="2" color={isSelected ? 'primary.500' : 'unset'}>
          {icon}
          <Text textStyle="normalBodyMedium">{title}</Text>
        </HStack>
        <SmallBullet isChecked={isSelected || false} />
      </HStack>
      <SimpleGrid columns={{ base: 2, laptop: 4 }} p="4" gap="3">
        {children}
      </SimpleGrid>
    </VStack>
  );
};

export default RiskObjectSelectRadio;
